<template>
  <div class="DocumentosPendentes">
    <div class="DocumentosPendentes_header mt-2">
      <div class="d-inline-flex col-10 m-0 p-0 px-2">
        <div class="form-group col-3 m-0 p-0 pr-4">
          <label for="tipo_data"
                 class="m-0 p-0 DocumentosPendentes_label mb-1">Tipo de data</label>
          <select id="tipo_data"
                  v-model="localData.tipo_data"
                  v-validate="{'required': !!localData.data_inicial || !!localData.data_final}"
                  class="form-control form-control-sm"
                  name="tipo_data"
                  :class="{'is-invalid': errors.has('tipo_data')}"
                  @change="changeDatas()">
            <option :value="null">
              Qualquer data
            </option>
            <option value="data_registro">
              Data de registro
            </option>
          </select>
          <span v-if="errors.has('tipo_data')"
                class="invalid-feedback">
            {{ errors.first("tipo_data") }}
          </span>
        </div>

        <div class="form-group col-3 m-0 p-0">
          <label for="data"
                 class="m-0 p-0 DocumentosPendentes_label mb-1">Data</label>
          <div id="data"
               class="d-inline-flex align-items-top">
            <div class="form-group m-0 p-0">
              <input id="inicio"
                     v-model="localData.data_inicial"
                     v-validate="{required: localData.tipo_data, max_date: new Date()}"
                     type="date"
                     name="inicio"
                     class="form-control form-control-sm"
                     :disabled="!localData.tipo_data"
                     :class="{'is-invalid': errors.has('inicio')}">
              <span v-if="errors.has('inicio')"
                    class="invalid-feedback">
                {{ localData.tipo_data && !localData.data_inicial ? "Campo obrigatório" : errors.first("inicio") }}
              </span>
            </div>
            <p class="p-0 m-0 mx-2 mt-1 DocumentosPendentes_label">
              até
            </p>
            <div class="form-group m-0 p-0">
              <input id="fim"
                     v-model="localData.data_final"
                     v-validate="{required: localData.tipo_data, max_date: new Date()}"
                     type="date"
                     name="fim"
                     class="form-control form-control-sm"
                     :class="{'is-invalid': errors.has('fim')}"
                     :disabled="!localData.tipo_data">
              <span v-if="errors.has('fim')"
                    class="invalid-feedback">
                {{ localData.tipo_data && !localData.data_final ? "Campo obrigatório" : errors.first("fim") }}
              </span>
            </div>
          </div>
        </div>
      </div>
      <div class="col-8 m-0 p-0 my-2 mx-2">
        <div class="form-group m-0 p-0">
          <label for="tipos"
                 class="m-0 p-0 DocumentosPendentes_label mb-1">Escolha o tipo de livro/registro:</label>
          <div id="tipos"
               class="d-inline-flex align-items-end mr-2 p-0 m-0">
            <button v-for="(type, index) in types"
                    :key="index"
                    class="btn_tipo_registro text-capitalize m-0 p-0 mr-2"
                    :class="{'btn_tipo_registro_active': type.value == localData.tipo_livro,
                             'btn_tipo_registro_required': required,
                             'd-none': type.value == 'E'}"
                    @click="localData.tipo_livro = type.value, required = false">
              <IconSvg :icon="type.icon"
                       class="icon--md btn_tipo_registro_icon"
                       :class="{'btn_tipo_registro_icon_active': type.value == localData.tipo_livro}" /><br>
              {{ type.text }}
            </button>
            <div class="form-group p-0 m-0 mr-2 col-2">
              <label for="livro"
                     class="m-0 p-0 DocumentosPendentes_label">Livro</label>
              <input v-model="localData.num_livro"
                     min="1"
                     type="number"
                     class="form-control form-control-sm"
                     placeholder="00000">
            </div>
            <button class="btn btn-outline-primary btn-sm px-4"
                    @click="searchPendentes()">
              Listar
            </button>
          </div>
        </div>
        <span v-if="required"
              class="text-invalid">
          Escolha o tipo de livro/registro
        </span>
      </div>
    </div>

    <div v-if="lista.length"
         class="DocumentosPendentes_body mt-2">
      <hr class="DocumentosPendentes_hr">
      <div class="d-inline-flex col-12 m-0 p-0 px-2 justify-content-between align-items-center">
        <b-form-checkbox
          v-model="select_all"
          :value="true">
          Selecionar todos
        </b-form-checkbox>
        <Pagination
          :page="page"
          :last-page="lastPage"
          :per-page="perPage"
          @onPreviousPage="reload(page - 1)"
          @onNextPage="reload(page + 1)" />
        <div class="d-inline-flex align-items-center">
          <label for="mostrar_qtd"
                 class="m-0 p-0 px-2 label_mostrar">Mostrar</label>
          <select id="mostrar_qtd"
                  v-model="perPage"
                  class="form-control form-control-sm"
                  @change="reload(1)">
            <option v-for="(qtd, index) in qtdList"
                    :key="index"
                    :value="qtd">
              {{ qtd }}
            </option>
          </select>
        </div>
      </div>
      <ListagemDocs :prop-select-all="select_all"
                    :prop-lista="lista"
                    :prop-selecteds="newSelecteds"
                    @change="getChanges" />
      <div class="DocumentosPendentes_acoes col-12 d-inline-flex justify-content-end align-items-center p-0 m-0 p-4 mt-2">
        <button class="btn btn-outline-danger btn-sm mr-2 btn_delete_forever"
                :disabled="!selecteds.length"
                @click=" deleteDocuments()">
          <IconSvg icon="deleteForever"
                   class="icon--sm icon_delete" />
          Excluir
        </button>
        <button class="btn btn-sm btn_assinar"
                :disabled="!selecteds.length"
                @click="obterCertificados()">
          <IconSvg icon="done"
                   class="icon--sm icon_done" />
          Assinar
        </button>
      </div>
    </div>
    <b-modal ref="modalCertificados"
             hide-footer
             title="Selecione um certificado"
             size="lg">
      <grid-certificados v-if="certificados && certificados.length > 0"
                         :certificados="certificados"
                         @onSelectCertificado="onSelectCertificado" />
    </b-modal>
  </div>
</template>
<script>
  /* components */
  import Pagination from "@/components/SofiaRei/Pagination"
  import ListagemDocs from "./ListagemDocsPendentes"

  /* libraries */
  import { mapGetters } from "vuex"

  /* services */
  import ArquivosService from '@/services/Arquivos/ArquivosService'
  import AssinaturasPendentesService from '@/services/Assinaturas/Registros/AssinaturasPendentesService'
  import BryService from '@/services/Assinaturas/BryService'

  export default {
    name: "DocumentosPendentes",
    components: {
      Pagination,
      ListagemDocs
    },
    data () {
      return {
        types: [
          {text: 'nascimento', icon: 'nascimento', value: 'N'},
          {text: 'casamento', icon: 'engagement', value: 'C'},
          {text: 'óbito', icon: 'flower', value: 'O'},
          {text: 'livro e', icon: 'book', value: 'E'},
        ],
        localData: {
          tipo_livro: null,
          cartorio_id: this.$store.state.auth.cartorio_id,
          num_livro: null,
          status: null,
          tipo_data: null,
          data_inicial: null,
          data_final: null,
          perPage: 10
        },
        select_all: false,
        lista: [],
        page: 1,
        lastPage: 1,
        perPage: 10,
        total: null,
        required: false,
        search: {},
        newSelecteds: [],
        selecteds: [],
        exceptions: [],
        qtdList: [10,30,50,100,500,1000],
        certificados: [],
        certificadoSelecionado: null
      }
    },
    computed: {
      ...mapGetters({
        cartorioId: 'auth/getCartorioId'
      })
    },
    methods: {
      async searchPendentes () {
        const valid = await this.$validator.validate()

        if (!this.localData.tipo_livro) {
          this.required = true
          return
        } else {
          this.required = false
        }

        if (!valid) return

        try {
          loader({active: true, text: "Buscando..."})

          const params = {
            ...this.localData,
            perPage: this.perPage,
            page: this.page,
          }

          this.search = {...this.localData}
          this.newSelecteds = []
          this.select_all = false

          const res = await AssinaturasPendentesService.getPendentes(params)

          this.lista = res.data
          this.page = res.page
          this.perPage = res.perPage
          this.lastPage = res.lastPage
          this.total = res.total

          if (!this.lista.length) {
            this.displayError("Nenhum documento encontrado", "")
          } else {
            this.scrollList()
          }

        } catch ({response}) {
          const text = response.data.error.message || null
          this.displayError("Erro!", text || "Não foi possível realizar a pesquisa.")
        } finally {
          loader({active: false, text: ""})
        }
      },
      async reload (page = 1) {
        try {
          loader({active: true, text: "Buscando..."})

          const params = {
            ...this.search,
            perPage: this.perPage,
            page: page
          }

          const res = await AssinaturasPendentesService.getPendentes(params)

          this.select_all = false
          this.lista = res.data
          this.page = res.page
          this.perPage = res.perPage
          this.lastPage = res.lastPage

          if (!this.lista.length) {
            this.displayError("Nenhum documento encontrado", "")
          }

        } catch ({response}) {
          const text = response.data.error.message || null
          this.displayError("Erro!", text || "Não foi possível realizar a pesquisa.")
        } finally {
          loader({active: false, text: ""})
        }
      },
      getChanges (selecteds, exceptions) {
        this.selecteds = selecteds
        this.exceptions = exceptions

        if (!selecteds.length) this.select_all = false
      },
      deleteDocuments () {
        if (!this.selecteds.length) {
          return this.displayError("Erro!", "Nenhum documento selecionado.")
        }

        this.displayQuestion(`Tem certeza que deseja excluir ${this.selecteds.length} ${this.selecteds.length > 1 ? "documentos" : "documento"}?`, "")
          .then(async res => {
            if (res.value) {
              try {
                loader({active: true, text: "Excluindo documentos..."})

                for (const selected of this.selecteds) {
                  await ArquivosService.removeArquivo(selected)
                }

                await this.displaySuccess("Sucesso!", `${this.selecteds.length} ${this.selecteds.length > 1 ? "documentos excluidos" :  "documento excluido"} com sucesso!`)
                  .then(() => this.reload())
              } catch ({response}) {
                const text = response.data.error.message || null
                this.displayError("Erro!", text || "Não foi possível realizar a pesquisa.")
              } finally {
                loader({active: false, text: ""})
              }
            }
          })
      },
      displayError (title, text) {
        objSwal.error.title = title
        objSwal.error.text = text
        objSwal.error.html = ""

        return Swal.fire(objSwal.error)
      },
      displaySuccess (title, text) {
        objSwal.success.title = title
        objSwal.success.text = text
        objSwal.success.html = ""

        return Swal.fire(objSwal.success)
      },
      displayQuestion (title, text) {
        objSwal.question.title = title
        objSwal.question.text = text
        objSwal.question.html = ""
        objSwal.question.cancelButtonText = 'Não'
        objSwal.question.confirmButtonText = 'Sim'

        return Swal.fire(objSwal.question)
      },

      async obterCertificados () {
        if (!BryService.isExtensionInstalled()) {
          this.displayError('', 'Certificados não instalados.')
        }

        if (!this.selecteds.length) return this.displayError("Erro!", "Nenhum documento selecionado!")

        loader({ text: 'Obtendo certificados...', active: true })

        this.certificados = await BryService.getCertificates()

        loader({ text: '', active: false })

        if (this.certificados.length === 0) {
          this.displayError('', 'Nenhum Certificado encontrado.')
        }

        if (this.certificados.length > 1) {
          this.$refs.modalCertificados.show()
        } else {
          this.certificadoSelecionado = this.certificados[0]

          // Anulando certificados obtidos
          this.certificados = null

          await this.assinarDocumentos()
        }
      },
      onSelectCertificado (certificado) {
        this.certificadoSelecionado = certificado
        // Fechando modal
        this.$refs.modalCertificados.hide()
        // Anulando certificados obtidos
        this.certificados = null
        // Assinando documentos
        return this.assinarDocumentos()
      },
      async assinarDocumentos () {
        loader({ text: 'Assinando documentos...', active: true })

        try {
          //Filtra a lista para retornar apenas o documento_id dos documentos selecionados
          const lista = this.lista.filter(item => {
            return this.selecteds.find(selected => item.arquivo_id == selected)
          }).map(item => item.documento_id)

          const { nonce, assinaturasInicializadas } = await BryService.startSigning(
            this.certificadoSelecionado.certificateData,
            lista
          )

          const assinaturasObj = assinaturasInicializadas.map(({ nonce, messageDigest }) => {
            return BryService.prepareContentForSignature(messageDigest, nonce)
          })

          const { certId } = this.certificadoSelecionado
          const { assinaturas } = await BryService.signBase64Content(certId, assinaturasObj)

          await BryService.endSigning(nonce, assinaturas)

          this.displaySuccess("Sucesso!", `${this.selecteds.length} ${this.selecteds.length > 1 ? "documentos assinados" :  "documento assinado"} com sucesso!`)
            .then(() => {
              this.reload()
              this.scrollList()
            })
        } catch ({response}) {
          return this.displayError(`Não foi possível assinar os documentos.`, response.data.message || "")
        } finally {
          loader({active: false, text: ""})
        }
      },
      scrollList () {
        setTimeout(() => {
          const listagem = document.querySelectorAll('.btn_tipo_registro')

          if (listagem.length) {
            listagem[0].scrollIntoView({ behavior: 'smooth', block: 'start', inline: "start" })
          }
        }, 100)
      },
      changeDatas () {
        if (!this.localData.tipo_data) {
          this.localData.data_inicial = null
          this.localData.data_final = null
        }
      }
    }
  }
</script>
<style lang="scss">

  .DocumentosPendentes {
    &_label {
      font-family: Roboto;
      font-size: 16px;
      font-weight: 500;
      color: #373a3c;
    }

    &_hr {
      height: 0px;
      border: solid 1px #074f7f;
    }

    &_acoes {
      border: solid 1px #707070;
      background: #ffffff;
      position: sticky;
      bottom: 10px;
      z-index: 2;
    }
  }

  .btn_tipo_registro {
    width: 100px !important;
    height: 80px !important;
    border-radius: 2px;
    border: solid 1px #696969;
    font-size: 16px;
    font-weight: 500;
    color: #696969;
    background: #FFFFFF;

    &_icon {
      fill: #FFFFFF;
      stroke: #696969;
      stroke-width: 1px;

      &_active {
        stroke: none;
        stroke-width: 0px;
      }
    }

    &_active {
      background: #074f7f !important;
      color: #FFFFFF !important;
      outline: none;
      border: solid 1px  #074f7f;
    }

    &_required {
      border: solid 1px  #FF0000;
    }
  }

  .btn_tipo_registro:focus {
    background: #074f7f !important;
    color: #FFFFFF !important;
    outline: none;
    border: solid 1px  #074f7f;
  }

  .btn_tipo_registro:focus > [class*=btn_tipo_registro_icon] {
    stroke: none;
    stroke-width: 0px;
  }

  .label {
    &_selecionar {
      font-size: 16px;
      font-weight: normal;
      color: #373a3c;
    }

    &_mostrar {
      font-family: Roboto;
      font-size: 16px;
      font-weight: 500;
      color: #373a3c;
    }
  }

  .icon {
    &_delete {
      fill: red;
      width: 20px;
      height: 20px;
    }

    &_done {
      fill: #FFFFFF;
      width: 20px;
      height: 20px;
    }
  }

  .btn {
    &_delete_forever {
      font-size: 16px !important;
      font-weight: normal;
      text-align: center;
    }

    &_delete_forever:hover:not(:disabled) > [class*=icon_delete] {
      fill: #FFFFFF !important;
    }

    &_assinar {
      border: solid 1px #205e3b;
      background: #205e3b;
      font-size: 16px;
      font-weight: normal;
      text-align: center;
      color: #ffffff;
      fill: #FFFFFF;
    }

    &_assinar:hover {
      color: #ffffff;
    }
  }

  .text-invalid {
    font-size: 14px;
    color: #ED0909;
  }
</style>
